export const filters = {
  excludeNewWounds: "Exclude new wounds that resolved in time range",
  includeDischarged: "Include discharged"
};
